import { Collapse, keyframes, styled, useMediaQuery } from '@mui/material'
import { ReactNode } from 'react'

const MOTION_MS = 200

export const useMotionMs = () => (useMediaQuery('(prefers-reduced-motion: reduce)') ? 0 : MOTION_MS)

const fadeIn = keyframes`
    from { opacity: 0; transform: scale(0.85); }
`

const Inner = styled('div')({
    animation: `${fadeIn} ${MOTION_MS}ms ease-out backwards`,
    transition: `opacity ${MOTION_MS}ms ease-out, transform ${MOTION_MS}ms ease-out`,
    '@media (prefers-reduced-motion: reduce)': { animation: 'none', transition: 'none' },
})

type Props = {
    show: boolean
    children: ReactNode
    // the row's spacing lives here: a flex gap would stay behind a folded slot and jump when it unmounts
    gutter?: string
    delay?: number
}

// A control-row slot: fades in when it mounts, and folds away (width + fade) when hidden, so the rest of the
// row glides instead of jumping.
export const ControlSlot = ({ show, children, gutter, delay = 0 }: Props) => {
    const motionMs = useMotionMs()

    return (
        <Collapse in={show} orientation="horizontal" timeout={motionMs} unmountOnExit sx={{ flexShrink: 0 }}>
            <Inner
                style={{
                    padding: gutter,
                    animationDelay: `${delay}ms`,
                    opacity: show ? 1 : 0,
                    transform: show ? 'none' : 'scale(0.85)',
                }}
            >
                {children}
            </Inner>
        </Collapse>
    )
}
